let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5cHi5"), load("cza5I"), load("82QsP")]).then(() => parcelRequire('lcEzf'));